import React, { useContext, useEffect } from 'react';
import Cookie from 'js-cookie';
import { useMedia, useSubmitAndCloseOnTimeout } from '@qover/hooks';
import { EmailModal } from './EmailModal';
import { ThemeContext } from '@qover/styles/src/ThemeContext';

type EmailModalProps = {
  bindToWindowObject?: boolean;
  draftId?: string;
  onSubmit: (form: any) => Promise<unknown>;
  showEmailModal: boolean;
  email?: string;
  disabled?: boolean;
};

const pushEmail = (label: string) => {
  // @ts-ignore
  dataLayer.push({
    event: 'saveMyOffer',
    eventCategory: 'save my offer',
    eventAction: 'exit intent open modal',
    eventLabel: label,
  });
};

const pushEmailOpen = () => pushEmail('open');
const pushEmailSubmit = () => pushEmail('send email');
const pushEmailClose = () => pushEmail('close');

export const EmailModalPopup: React.FC<EmailModalProps> = props => {
  const theme = useContext<any>(ThemeContext);
  const showSendMyOfferOnLeave = theme?.featureToggles?.showSendMyOfferOnLeave;
  const isMobile = useMedia(['(max-width: 767px)'], [true], false);

  const emailPopupAlreadyOpen = Cookie.get(
    `email-popup-already-shown-${props.draftId}`,
  );

  const onSubmit = (form: any) => {
    pushEmailSubmit();
    return props.onSubmit(form);
  };
  const { isOpen, setIsOpen, submitAndClose } = useSubmitAndCloseOnTimeout(
    onSubmit,
  );

  useEffect(() => {
    if (isOpen && !emailPopupAlreadyOpen) {
      pushEmailOpen();
    }
  }, [isOpen, emailPopupAlreadyOpen]);

  const showEmailPopup = (event: MouseEvent) => {
    if (
      (event === undefined ||
        event.clientY <= 0 ||
        event.clientX <= 0 ||
        event.clientX >= window.innerWidth ||
        event.clientY >= window.innerHeight) &&
      typeof document !== 'undefined' &&
      document.getElementById('modal-root')?.childNodes.length === 0
    ) {
      setIsOpen(true);
    }
  };

  useEffect(() => {
    if (!isMobile && showSendMyOfferOnLeave && props.showEmailModal) {
      document.body.addEventListener('mouseleave', showEmailPopup);
    }

    return () => {
      document.body.removeEventListener('mouseleave', showEmailPopup);
    };
  }, [props.showEmailModal]);

  useEffect(() => {
    if (props.bindToWindowObject) {
      // @ts-ignore
      window.showEmailPopup = showEmailPopup;
    }
  }, []);

  if (!isOpen || emailPopupAlreadyOpen) {
    return null;
  }

  return (
    <EmailModal
      onSubmit={submitAndClose}
      onClose={() => {
        pushEmailClose();
        setIsOpen(false);
        Cookie.set(`email-popup-already-shown-${props.draftId}`, 'true');
      }}
      email={props.email}
      disabled={props.disabled}
    />
  );
};

export default EmailModalPopup;
